import React, { useState, useEffect } from 'react';
import Navbar from './Navbar';
import QA from './QA';
import '../fonts.css';
import API_BASE_URL from '../api';

const UserPreferences = () => {
  const [preferences, setPreferences] = useState({
    gender: '',
    min_age: '',
    max_age: '',
    location: '',
  });

  const [message, setMessage] = useState('');
  const [isNewUser, setIsNewUser] = useState(false); // New state to track if the user is new

  // Utility function to get auth token from localStorage
  const getAuthToken = () => localStorage.getItem('stack_access_token');

  useEffect(() => {
    const token = getAuthToken();
    fetch(`${API_BASE_URL}/api/preferences`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Stack-Access-Token': token,
      },
    })
      .then((response) => {
        if (response.status === 404) {
          // Handle the case where preferences are not set
          setIsNewUser(true); // Mark the user as new to prompt setting preferences
          setMessage('No preferences found. Please set your preferences.');
          return; // Early exit from the function
        }
        if (!response.ok) {
          throw new Error('Failed to fetch preferences');
        }
        return response.json();
      })
      .then((data) => {
        if (data) setPreferences(data);
      })
      .catch((error) => {
        console.error('Error fetching preferences:', error);
        setMessage('Error fetching preferences.');
      });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const token = getAuthToken();

    // Validation check
    if (parseInt(preferences.min_age) >= parseInt(preferences.max_age)) {
      setMessage('Minimum age must be less than maximum age.');
      return;
    }

    // Determine the correct HTTP method based on isNewUser state
    const method = isNewUser ? 'POST' : 'PUT';

    try {
      const response = await fetch(`${API_BASE_URL}/api/preferences`, {
        method: method,
        headers: {
          'X-Stack-Access-Token': token,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(preferences),
      });

      if (!response.ok) {
        throw new Error('Failed to update preferences');
      }

      const result = await response.json();
      setPreferences(result);
      setMessage('Preferences updated successfully.');
      setIsNewUser(false); // Reset isNewUser since preferences are now set
    } catch (error) {
      console.error('Error setting preferences:', error);
      setMessage('Failed to update preferences.');
    }
  };

  const handleChange = (e) => {
    console.log('Target Name:', e.target.name);
    console.log('Target Value:', e.target.value);
    setPreferences({
      ...preferences,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div
      className="flex flex-col justify-between min-h-screen"
      style={{ backgroundColor: '#0D2329' }}
    >
      <Navbar />
      <div className="flex-1 w-full space-y-8 p-6 rounded-xl shadow-lg text-white">
        <div
          className="max-w-md w-full mx-auto p-8 rounded-lg shadow-md"
          style={{ backgroundColor: '#05664f' }}
        >
          <h1
            className="text-4xl font-bold text-white text-center mb-6"
            style={{ fontFamily: 'Inter', textTransform: 'uppercase' }}
          >
            Preferences
          </h1>
          {message && (
            <p className="text-sm text-red-200 text-center mb-4">{message}</p>
          )}
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="text-white">
              <label className="block text-sm font-medium">
                Gender
                <select
                  name="gender"
                  value={preferences.gender || ''}
                  onChange={handleChange}
                  className="mt-1 block w-full px-3 py-2 text-base border border-gray-300 text-black focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md"
                >
                  <option value="" disabled>
                    Select gender
                  </option>
                  <option value="female">Female</option>
                  <option value="male">Male</option>
                  <option value="other">Other</option>
                </select>
              </label>
            </div>
            <div className="grid grid-cols-2 gap-4 text-white">
              <label className="block text-sm font-medium">
                Minimum Age
                <input
                  type="number"
                  name="min_age"
                  value={preferences.min_age || ''}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 text-black rounded-md focus:outline-none focus:ring-d1ff5d focus:border-d1ff5d sm:text-sm"
                />
              </label>
              <label className="block text-sm font-medium">
                Maximum Age
                <input
                  type="number"
                  name="max_age"
                  value={preferences.max_age || ''}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 text-black rounded-md focus:outline-none focus:ring-d1ff5d focus:border-d1ff5d sm:text-sm"
                />
              </label>
            </div>
            <div className="text-white">
              <label className="block text-sm font-medium">
                Location
                <input
                  type="text"
                  name="location"
                  value={preferences.location || ''}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 text-black rounded-md focus:outline-none focus:ring-d1ff5d focus:border-d1ff5d sm:text-sm"
                />
              </label>
            </div>
            <button
              type="submit"
              className="w-full px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-black focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              UPDATE
            </button>
          </form>
        </div>
        <QA />
        <div className="mt-10 flex items-center justify-center gap-x-6">
          <a
            href="/profile"
            className="w-50 justify-center py-3 px-6 border border-transparent rounded-md shadow-sm text-lg font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            style={{ backgroundColor: '#05664f' }}
          >
            Set Up Your Profile
          </a>
        </div>
      </div>
    </div>
  );
};

export default UserPreferences;
